import React from "react";
import './About.css'
import { Link } from "react-router-dom";
import Aboutusimage from '../../assets/Home/Aboutusimage.png'
import managerimage from '../../assets/About/tauc-owner.png'
import { Chrono } from "react-chrono";
import Vector from '../../assets/About/Vector.png'
import Vector1 from '../../assets/About/Vector1.png'
import Quality from '../../assets/About/Quality.png'
import Safety from '../../assets/About/Safety.png'
import Sustainability from '../../assets/About/Sustainability.png'
import People from '../../assets/About/People.png'
import civil from '../../assets/About/civil.png'
import Electrical from '../../assets/About/Electrical.png'
import Mechanical from '../../assets/About/Mechanical.png'
import Telecom from '../../assets/About/Telecom.png'
import Epc from '../../assets/About/Epc.png'
import leader1 from '../../assets/About/Ahmed Hassan Mohammed.png'
import leader2 from '../../assets/About/Saad Abdullah Al Aqili.png'
import leader3 from '../../assets/About/Fatima Al Rashid.png'
import project1 from '../../assets/About/Expansion Phase.png'
import project2 from '../../assets/About/Major Projects Era.png'
import project3 from '../../assets/About/Founded in Riyadh.png'
import project4 from '../../assets/About/Industry Leader.png'
import rightarrow from '../../assets/About/rightarrow.png'
import vectorEye from '../../assets/About/Vector eye.png'
import vectorMission from '../../assets/About/Vector mission.png'
import BlueRightArrow from '../../assets/Contactus/blue-right-arrow.png'
import person3 from '../../assets/About/person-3.png'
import person1 from '../../assets/About/person-1.jpeg'
import person2 from '../../assets/About/person-2.png'


// const items = [{
//       title: "2001",
//       cardTitle: "2001",
//       cardSubtitle:"Founded in Riyadh",
//       cardSubtitle: "Men of the British Expeditionary Force (BEF) wade out to..",
    
//     },
//   {
//       title: "May 1940",
//       cardTitle: "Dunkirk",
//       url: "http://www.history.com",
//       cardSubtitle:"Men of the British Expeditionary Force (BEF) wade out to..",
//       cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
//       media: {
//         type: "IMAGE",
//         source: {
//           url: "http://someurl/image.jpg"
//         }
//       }
//     },
//   {
//       title: "May 1940",
//       cardTitle: "Dunkirk",
//       url: "http://www.history.com",
//       cardSubtitle:"Men of the British Expeditionary Force (BEF) wade out to..",
//       cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
//       media: {
//         type: "IMAGE",
//         source: {
//           url: "http://someurl/image.jpg"
//         }
//       }
//     },
//     {
//       title: "May 1940",
//       cardTitle: "Dunkirk",
//       url: "http://www.history.com",
//       cardSubtitle:"Men of the British Expeditionary Force (BEF) wade out to..",
//       cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
//       media: {
//         type: "IMAGE",
//         source: {
//           url: "http://someurl/image.jpg"
//         }
//       }
//     },
//     {
//       title: "May 1940",
//       cardTitle: "Dunkirk",
//       url: "http://www.history.com",
//       cardSubtitle:"Men of the British Expeditionary Force (BEF) wade out to..",
//       cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
//       media: {
//         type: "IMAGE",
//         source: {
//           url: "http://someurl/image.jpg"
//         }
//       }
//     },{
//       title: "May 1940",
//       cardTitle: "Dunkirk",
//       url: "http://www.history.com",
//       cardSubtitle:"Men of the British Expeditionary Force (BEF) wade out to..",
//       cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
//       media: {
//         type: "IMAGE",
//         source: {
//           url: "http://someurl/image.jpg"
//         }
//       }
//     },{
//       title: "May 1940",
//       cardTitle: "Dunkirk",
//       url: "http://www.history.com",
//       cardSubtitle:"Men of the British Expeditionary Force (BEF) wade out to..",
//       cardDetailedText: "Men of the British Expeditionary Force (BEF) wade out to..",
//       media: {
//         type: "IMAGE",
//         source: {
//           url: "http://someurl/image.jpg"
//         }
//       }
//     },]

const About = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // or 'auto'
  };
  
  return (
    <>
    <div className="about-image-container">
        <div className="overlay-text-container">
          <h1 className="about-main-heading">About TAUC – Engineering Excellence Since 2001</h1>
          <p className="about-main-description">A trusted Saudi construction leader in Oil & Gas, Power, Water, and Infrastructure.</p>
        </div>
      </div>

      <div className="manager-section-main-container">
        <div className="manager-section">
          <div className="image-section">
            <img src={managerimage} className="manager-image" alt="Manager-image" />
          </div>

          <div className="manager-section-content-container">
            <h1 className="manager-heading">Message from Our General Manager</h1>
            <div className="horizantal-line">
          <div className="line"></div>
        </div>
            <p className="manager-content">At TAUC, we are proud to be part of the Kingdom's Vision 2030, contributing to the transformation of Saudi Arabia through innovative engineering solutions and world-class construction services.</p>
            <p className="manager-content">Our commitment to excellence, safety, and sustainability drives everything we do. Through teamwork and dedication, we continue to deliver projects that support national development and economic growth.</p>

            <div className="quote-container">
              <p className="quote">"We build for today, while shaping the Kingdom's future."</p>
            </div>

            <p className="manager-name">Turky Mohammed Matar Al Utaibi</p>
            <p className="manager-role">CHAIRMAN</p>
          </div>
        </div>
      </div>

      <div className="chrono-container">
        <h1 className="our-story-heading">Our Story</h1>
        <div className="horizantal-line">
          <div className="line"></div>
        </div>
        <p className="our-story-content">Over two decades of engineering excellence and continuous growth in the Kingdom</p>

        <Chrono mode="VERTICAL_ALTERNATING" theme={{
          primary: 'black',
          secondary: 'white',
          cardBgColor: 'white',
          cardForeColor: 'black',
          titleColor: 'black',
        }} disableNavOnKey hideControls >
        <div className="project-cards">
          <img src= {project3} className="project-image" alt="project-image" />
          <div className="project-content">
            <p className="project-year">2001</p>
            <h1 className="project-title">Founded in Riyadh</h1>
            <p className="project-info">TAUC established as a Saudi construction company with a vision
            to serve the Kingdom's growing infrastructure needs.</p>
          </div>
        </div>

        <div className="project-cards">
          <img src= {project1} className="project-image" alt="project-image" />
          <div className="project-content">
            <p className="project-year">2005-2015</p>
            <h1 className="project-title">Expansion Phase</h1>
            <p className="project-info">Strategic expansion into Telecom & Water Networks, establishing
            our expertise in critical infrastructure development.</p>
          </div>
        </div>

        <div className="project-cards">
          <img src= {project2} className="project-image" alt="project-image" />
          <div className="project-content">
            <p className="project-year">2016-2020</p>
            <h1 className="project-title">Major Projects Era</h1>
            <p className="project-info"> Secured major Oil & Gas contracts and Aramco projects,
            becoming a trusted partner in the energy sector.</p>
          </div>
        </div>

        <div className="project-cards">
          <img src= {project4} className="project-image" alt="project-image" />
          <div className="project-content">
            <p className="project-year">2021-2025</p>
            <h1 className="project-title">Industry Leader</h1>
            <p className="project-info">Recognized as an industry leader in EPC, Power, Petrochemicals,
            and Infrastructure development across the Kingdom.</p>
          </div>
        </div>
        
      </Chrono>
      </div>

      <div className="vision-and-mission-main-container">
        <h1 className="vision-heading">Vision & Mission</h1>
        <div className="horizantal-line">
          <div className="line"></div>
        </div>
        <p className="vision-content">Guiding principles that drive our commitment to excellence</p>

        <div className="vision-card-container">
          <div className="vision-card">
            <div className="vision-icon-container">
              <div className="icon-container">
                <img src={vectorEye} className="vision-image" alt="vision-image" />
              </div>
              <h2 className="vision-sub-heading">Our Vision</h2>
            </div>
            <p className="vision-card-content">To be recognized as the best one-stop destination for Engineering, Procurement, Construction, Commissioning, and Maintenance.</p>
          </div>

          <div className="vision-card">
            <div className="vision-icon-container">
              <div className="icon-container">
                <img src={Vector1} className="vision-image" alt="vision-image" />
              </div>
              <h2 className="vision-sub-heading">Our Mission</h2>
            </div>
            <p className="vision-card-content">Delivering safe, innovative, and cost-effective solutions that exceed client expectations.</p>
          </div>

        </div>
      </div>

      <div className="values-and-commitments">
        <h1 className="values-heading">Our Values & Commitments</h1>
        <div className="horizantal-line">
          <div className="line"></div>
        </div>
        <p className="values-content">The foundation of everything we do</p>

        <div className="value-cards-container">
          <div className="value-card">
            <div className="quality-icon-container">
              <img src={Quality} className="value-quality-image" alt="quality-image" />
            </div>
            <h1 className="value-card-heading">Quality</h1>
            <p className="value-card-content">ISO 9001:2015 compliance ensuring the highest standards in all our deliverables.</p>
            <div className="value-card-footer value-card-footer-quality">
              <p className="value-card-footer-message value-card-footer-message-quality">ISO 9001:2015</p>
            </div>
          </div>

          <div className="value-card">
            <div className="safety-icon-container">
              <img src={Safety} className="value-quality-image" alt="quality-image" />
            </div>
            <h1 className="value-card-heading">Safety</h1>
            <p className="value-card-content">OHSAS 45001:2018 certified with a "Safety First" culture in every project.</p>

            <div className="value-card-footer value-card-footer-safety">
              <p className="value-card-footer-message value-card-footer-message-safety">OHSAS 45001:2018</p>
            </div>          
            </div>

          <div className="value-card">
            <div className="sustainability-icon-container">
              <img src={Sustainability} className="value-quality-image" alt="quality-image" />
            </div>
            <h1 className="value-card-heading">Sustainability</h1>
            <p className="value-card-content">ISO 14001:2015 environmental responsibility in all our operations.</p>
            <div className="value-card-footer value-card-footer-sustainability">
              <p className="value-card-footer-message value-card-footer-message-sustainabliity">ISO 14001:2015</p>
            </div>   
          </div>

          <div className="value-card">
            <div className="people-icon-container">
              <img src={People} className="value-quality-image" alt="quality-image" />
            </div>
            <h1 className="value-card-heading">People</h1>
            <p className="value-card-content">Skilled multinational workforce with continuous training & development.</p>
            <div className="value-card-footer value-card-footer-people">
              <p className="value-card-footer-message value-card-footer-message-people">Expert Team</p>
            </div>   
          </div>
        </div>
      </div>

      <div className="our-capabilities-main-container">
        <h1 className="our-capabilities-heading">Our Capabilities</h1>
        <div className="horizantal-line">
          <div className="line"></div>
        </div>
        <p className="our-capabilities-content">Comprehensive engineering and construction services</p>
        <div className="our-capabilities-cards">
        <div className="our-capabilities-cards-container">
          <div className="our-capabilities-card">
            <div className="our-capabilities-image-container">
              <img src={civil} className="our-capabilities-image" alt="our-capabilities-image" />
            </div>
            <h1 className="our-card-capabilities-heading">Civil & Structural</h1>
            <p className="our-card-capabilities-content">Comprehensive civil and structural engineering solutions for complex infrastructure projects.</p>
          </div>
        </div>
        <div className="our-capabilities-cards-container">
          <div className="our-capabilities-card">
            <div className="our-capabilities-image-container">
              <img src={Mechanical} className="our-capabilities-image" alt="our-capabilities-image" />
            </div>
            <h1 className="our-card-capabilities-heading">Mechanical & Piping</h1>
            <p className="our-card-capabilities-content">Advanced mechanical systems and piping solutions for industrial facilities.</p>
          </div>
        </div>

        <div className="our-capabilities-cards-container">
          <div className="our-capabilities-card">
            <div className="our-capabilities-image-container">
              <img src={Electrical} className="our-capabilities-image" alt="our-capabilities-image" />
            </div>
            <h1 className="our-card-capabilities-heading">Electrical & Instrumentation</h1>
            <p className="our-card-capabilities-content">Cutting-edge electrical and instrumentation systems for modern facilities.</p>
          </div>
        </div>
        <div className="our-capabilities-cards-container">
          <div className="our-capabilities-card">
            <div className="our-capabilities-image-container">
              <img src={Telecom} className="our-capabilities-image" alt="our-capabilities-image" />
            </div>
            <h1 className="our-card-capabilities-heading">Telecom & Security</h1>
            <p className="our-card-capabilities-content">Advanced telecommunications and security system installations.</p>
          </div>
        </div>
        <div className="our-capabilities-cards-container">
          <div className="our-capabilities-card">
            <div className="our-capabilities-image-container">
              <img src={Epc} className="our-capabilities-image" alt="our-capabilities-image" />
            </div>
            <h1 className="our-card-capabilities-heading">EPC & Project Management</h1>
            <p className="our-card-capabilities-content">End-to-end Engineering, Procurement, and Construction management.</p>
          </div>
        </div>
        
      </div>
      <div className="our-capabilities-button-container">
          {/* <button className="explore-our-services-button">Explore Our Services <img src={rightarrow} className="right-arrow"/></button> */}
          <Link to="/services" onClick={scrollToTop} className="explore-our-services-button">
            Explore Our Services <img src={rightarrow} alt="Right Arrow" className="right-arrow" />
          </Link>
        </div>
      </div>

      <div className="leadership-main-container">
        <h1 className="leadership-heading">Leadership & Organization</h1>
        <div className="horizantal-line">
          <div className="line"></div>
        </div>
        <p className="leadership-content">Meet the experienced team driving TAUC’S success</p>

        <div className="leaders-main-container">
          <div className="leader-info-card">
            <img src={person1} className="leader-image" alt="leader-image" />
            <h1 className="leader-name">Mohammed Nizamuddin</h1>
            <p className="leader-role">General Manager</p>
            <p className="leader-info">Leading TAUC strategic vision and operational excellence</p>
          </div>

          <div className="leader-info-card">
            <img src={person2} className="leader-image" alt="leader-image" />
            <h1 className="leader-name">Shafaqath Khan</h1>
            <p className="leader-role">Operations Manager</p>
            <p className="leader-info">Ensuring operational efficiency and quality standards</p>
          </div>

          <div className="leader-info-card">
            <img src={person3} className="leader-image" alt="leader-image" />
            <h1 className="leader-name">Abdul Raheem</h1>
            <p className="leader-role">Projects Manager</p>
            <p className="leader-info">Overseeing technical excellence and project delivery</p>
          </div>

        </div>
      </div>

      <div className="contact-us-main-container">
        <h1 className="contact-us-heading">Partner with a construction company built on trust and excellence</h1>
        <p className="contact-us-content">Join the leading organizations who trust TAUC for their most critical infrastructure projects</p>
        {/* <button className="contact-us-button">Contact Us Today </button> */}
        <Link to="/contact" onClick={scrollToTop} className="buttonStyleContact" style={{ color: "#1E3A8A" , textDecoration:"none"}}>
          Contact Us Today <img src={BlueRightArrow} alt="blue-right-arrow" className="blue-right-arrow" />
        </Link> 
      </div>

    </>
  );
};

export default About